import { Table } from "../../features/Table";
import { type User, users_columns } from "./columns";

const client = "legacy-quantilia";
const table_name = "users";

export const UsersTable = () => {
  return (
    <Table<User, unknown>
      label="Utilisateurs"
      client={client}
      table_name={table_name}
      columns={users_columns}
      disable_translations_request={true}
    />
  );
};
